import {createApp} from 'vue';
import MdFormsFormBuilder from './FormBuilder.vue'
import MdFormsPollBuilder from './PollBuilder.vue'
import MdFormsEntryList from './EntryList.vue'

let elements = document.getElementsByClassName('md-forms-app');
for (let el of elements) {
    let app = createApp({
        components: {
            MdFormsFormBuilder,
            MdFormsEntryList,
            MdFormsPollBuilder
        },
    });
    app.mount(el);
}